import classNames from 'classnames';
import { useState } from 'react';
import { formatNumberShort } from '../../../../../../lib/utils/format';
import Button from '../../../../../Button';
import Spinner from '../../../../../Icons/Spinner';

export default function MessageAction({ Icon, count, className, label, onClick, href = null }) {
  const [isLoading, setIsLoading] = useState(false);
  const [reaction, setReaction] = useState(null);

  const wrapperClasses = classNames('action');

  const iconClasses = classNames('action-button', className, {
    'animate-pulse': isLoading,
  });

  const clickHandler = () => {
    if (href || !onClick) {
      return null;
    }

    return () => {
      const { data, action } = onClick();
      if (action && (!reaction || (reaction && reaction.marked === data.marked))) {
        setIsLoading(true);
        action()
          .then((response) => setReaction(response))
          .finally(() => setIsLoading(false));
      }
    };
  };

  const handleClick = clickHandler();

  const getAs = () => {
    if (href) {
      return 'a';
    }

    if (!onClick) {
      return 'section';
    }

    return '';
  };
  const as = getAs();

  return (
    <Button
      className={wrapperClasses}
      href={href || null}
      onClick={handleClick}
      title={label}
      as={as}
      variant="clear"
      tabIndex={!count && !onClick && !href ? -1 : ''}
      ariaHidden={!count && !onClick && !href}
      role={!href && !onClick ? 'presentation' : ''}
    >
      <span className={iconClasses}>
        <Icon className="icon" />
        {isLoading && (
          <section className="loading-action">
            <Spinner className="icon" />
          </section>
        )}
      </span>
      {count !== undefined && <p className="count">{!!count && formatNumberShort(count)}</p>}
      <span className="sr-only">{label}</span>
    </Button>
  );
}
